import { useRouter } from "next/router";
import { useCallback, useMemo } from "react";
import { useRecoilValue } from "recoil";

import { isLoggedInState } from "@/atoms/accountState";

export const useGuidebookQuestion = () => {
  const isLoggedIn = useRecoilValue(isLoggedInState);
  const router = useRouter();

  const handleQuestionRouting = useCallback(() => {
    if (!isLoggedIn) {
      return router.push(`/login?redirectTo=${encodeURIComponent(router.asPath)}`);
    }

    router.push({ pathname: router.pathname, query: { ...router.query, edit: false } }, undefined, {
      scroll: false,
    });
  }, [isLoggedIn, router]);

  const edit = useMemo(() => {
    if (!router.isReady) return;
    if (router.query.edit == null) return;
    if (router.query.edit === "false") return -1;

    return Number(router.query.edit);
  }, [router.isReady, router.query.edit]);

  const handleCloseQuestioDrawer = useCallback(() => {
    const query = router.query;
    delete query.edit;

    router.push({ pathname: router.pathname, query }, undefined, { scroll: false });
  }, [router]);

  const isOpenQuestioDrawer = edit != null;

  return {
    handleQuestionRouting,
    isOpenQuestioDrawer,
    edit,
    handleCloseQuestioDrawer,
  };
};
